import { useState } from 'react';
import ImagePreviewThumbnail from './ImagePreviewThumbnail';
import ClickableImageFilename from './ClickableImageFilename';
import { type UploadedImage } from '@/lib/types';
import ImagePreviewDialog from './ImagePreviewDialog';
import shouldShowInappropriateContentIndicators from '@/lib/files/shouldShowInappropriateContentIndicators';
import NoImagePreviewThumbnail from './NoImagePreviewThumbnail';

type ImagePreviewProps = {
  image: UploadedImage;
};

const ImagePreview = ({ image }: ImagePreviewProps) => {
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);

  const showInappropriateContentIndicators =
    shouldShowInappropriateContentIndicators(image);

  return (
    <>
      {image.file.thumbnailStorageFilename !== null ? (
        <ImagePreviewThumbnail
          image={image}
          showInappropriateContentIndicators={
            showInappropriateContentIndicators
          }
          onClick={() => setPreviewDialogOpen(true)}
        />
      ) : (
        <NoImagePreviewThumbnail
          showInappropriateContentIndicators={
            showInappropriateContentIndicators
          }
          onClick={() => setPreviewDialogOpen(true)}
        />
      )}
      <ClickableImageFilename onClick={() => setPreviewDialogOpen(true)}>
        {image.file.originalFilename}
      </ClickableImageFilename>
      <ImagePreviewDialog
        image={image}
        showInappropriateContentIndicators={showInappropriateContentIndicators}
        open={previewDialogOpen}
        onClose={() => setPreviewDialogOpen(false)}
      />
    </>
  );
};

export default ImagePreview;
